import {
  CHECK_USER_EXISTS_REQUEST,
  CHECK_USER_EXISTS_SUCCEEDED,
  CHECK_USER_EXISTS_FAILED,
  CLEAR_USERS,
  CLEAR_SELECTED_USERS,
  FETCH_USERS_REQUEST,
  FETCH_USERS_SUCCEEDED,
  FETCH_USERS_FAILED,
  FETCH_USER_REQUEST,
  FETCH_USER_SUCCEEDED,
  FETCH_USER_FAILED,
  SEND_WELCOME_EMAIL_REQUEST,
  SEND_WELCOME_EMAIL_SUCCEEDED,
  SEND_WELCOME_EMAIL_FAILED,
  TOGGLE_ACTIVATE_USER_REQUEST,
  TOGGLE_ACTIVATE_USER_SUCCEEDED,
  TOGGLE_ACTIVATE_USER_FAILED,
  TOGGLE_USER
} from '../actions/userActions'
import uniq from 'lodash/uniq'

const initialState = {
  ids: [],
  existingUserId: null,
  page: 1,
  totalPages: 0,
  selectedUsers: [],
  sendingWelcomeEmail: false,
  isLoading: false,
  query: ''
}

const users = (state = initialState, action) => {
  switch (action.type) {
    case CLEAR_USERS:
      return { ...state, ids: [] }
    case CLEAR_SELECTED_USERS:
      return { ...state, selectedUsers: [] }
    case TOGGLE_USER:
      if (action.selected) {
        return {
          ...state,
          selectedUsers: uniq([...state.selectedUsers, action.userId])
        }
      }

      const idx = state.selectedUsers.indexOf(action.userId)

      if (idx === -1) {
        return state
      }

      return {
        ...state,
        selectedUsers: [
          ...state.selectedUsers.slice(0, idx),
          ...state.selectedUsers.slice(idx + 1)
        ]
      }
    case FETCH_USERS_REQUEST:
      return {
        ...state,
        isLoading: true,
        page: action.page || 1,
        query: action.query || ''
      }
    case CHECK_USER_EXISTS_REQUEST:
    case TOGGLE_ACTIVATE_USER_REQUEST:
    case FETCH_USER_REQUEST:
      return { ...state, isLoading: true }
    case FETCH_USERS_SUCCEEDED:
      const { response } = action

      return {
        ...state,
        isLoading: false,
        totalPages: (response.meta && response.meta.totalPages) || 1,
        ids: response.result
      }
    case CHECK_USER_EXISTS_SUCCEEDED:
      const { result } = action.response
      return { ...state, isLoading: false, existingUserId: result }
    case CHECK_USER_EXISTS_FAILED:
    case FETCH_USERS_FAILED:
    case FETCH_USER_FAILED:
    case FETCH_USER_SUCCEEDED:
    case TOGGLE_ACTIVATE_USER_SUCCEEDED:
    case TOGGLE_ACTIVATE_USER_FAILED:
      return { ...state, isLoading: false }
    case SEND_WELCOME_EMAIL_REQUEST:
      return { ...state, sendingWelcomeEmail: true }
    case SEND_WELCOME_EMAIL_FAILED:
    case SEND_WELCOME_EMAIL_SUCCEEDED:
      return { ...state, sendingWelcomeEmail: false }
    default:
      return state
  }
}

export default users



// WEBPACK FOOTER //
// ../src/reducers/users.js